import React from 'react';
import { GOLD } from '../constants/theme';

const Footer: React.FC = () => (
  <footer style={{ background:'#050505', borderTop:'1px solid rgba(196,152,50,0.1)' }}>
    <div style={{ padding:'60px 8vw 34px', display:'flex', gap:40, flexWrap:'wrap' }}>
      <div style={{ flex:'2 1 220px' }}>
        <div style={{ fontFamily:'Cormorant Garamond', fontSize:20, fontWeight:600, color:GOLD, letterSpacing:4 }}>Gowjee</div>
        <div style={{ fontFamily:'Montserrat', fontSize:7, letterSpacing:4, color:'rgba(196,152,50,0.52)', textTransform:'uppercase', marginBottom:16 }}>Caterers</div>
        <p style={{ fontFamily:'Montserrat', fontSize:11, color:'rgba(255,255,255,0.4)', lineHeight:1.9, maxWidth:260 }}>
          Crafting extraordinary culinary experiences for every occasion. Where passion meets perfection on every plate.
        </p>
        {/* <div style={{ display:'flex', gap:8, marginTop:20 }}>
          {['f','in','tw','yt'].map(s => (
            <a key={s} href="#" style={{ width:34, height:34, border:'1px solid rgba(196,152,50,0.28)', display:'flex', alignItems:'center', justifyContent:'center', color:GOLD, textDecoration:'none', fontFamily:'Montserrat', fontSize:9, fontWeight:700, textTransform:'uppercase', transition:'all 0.3s' }}
              onMouseOver={e => { (e.currentTarget as HTMLElement).style.background = GOLD; (e.currentTarget as HTMLElement).style.color = '#0a0a0a'; }}
              onMouseOut={e => { (e.currentTarget as HTMLElement).style.background = 'transparent'; (e.currentTarget as HTMLElement).style.color = GOLD; }}>{s}</a>
          ))}
        </div> */}
      </div>
      {[
        { t:'Quick Links', l:['Home','About Us','Menu','Live Stations','Gallery','Contact'] },
        { t:'Services',    l:['Wedding Catering','Corporate Events','Private Parties','Outdoor Events','Cocktail Events','Live Stations'] },
      ].map(col => (
        <div key={col.t} style={{ flex:'1 1 140px' }}>
          <h4 style={{ fontFamily:'Montserrat', fontSize:9, letterSpacing:3, color:GOLD, textTransform:'uppercase', marginBottom:16 }}>{col.t}</h4>
          {col.l.map(lk => (
            <a key={lk} href="#" style={{ display:'block', fontFamily:'Montserrat', fontSize:10, color:'rgba(255,255,255,0.4)', textDecoration:'none', marginBottom:8, transition:'color 0.2s' }}
              onMouseOver={e => (e.currentTarget as HTMLElement).style.color = GOLD}
              onMouseOut={e => (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.4)'}>› {lk}</a>
          ))}
        </div>
      ))}
      {/* <div style={{ flex:'1 1 180px' }}>
        <h4 style={{ fontFamily:'Montserrat', fontSize:9, letterSpacing:3, color:GOLD, textTransform:'uppercase', marginBottom:16 }}>Newsletter</h4>
        <p style={{ fontFamily:'Montserrat', fontSize:11, color:'rgba(255,255,255,0.4)', lineHeight:1.85, marginBottom:16 }}>Subscribe for exclusive menus and seasonal specials.</p>
        <div style={{ display:'flex' }}>
          <input placeholder="Your email" style={{ flex:1, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(196,152,50,0.2)', borderRight:'none', color:'#fff', fontFamily:'Montserrat', fontSize:11, padding:'10px 12px', outline:'none' }}/>
          <button style={{ background:GOLD, border:'none', color:'#0a0a0a', padding:'10px 13px', fontFamily:'Montserrat', fontSize:12, cursor:'pointer', fontWeight:700 }}>›</button>
        </div>
      </div> */}
    </div>
    <div style={{ borderTop:'1px solid rgba(196,152,50,0.07)', padding:'16px 8vw', display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:8 }}>
      <p style={{ fontFamily:'Montserrat', fontSize:9, color:'rgba(255,255,255,0.25)', letterSpacing:1 }}>© 2026 Gowjee Caterers. All rights reserved.</p>
      <p style={{ fontFamily:'Montserrat', fontSize:9, color:'rgba(255,255,255,0.25)', letterSpacing:1 }}>Privacy Policy · Terms of Service</p>
    </div>
  </footer>
);

export default Footer;